"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var FormatButton_1 = require("./FormatButton");
var toggleColorMenuIsShown_1 = require("../actions/toggleColorMenuIsShown");
var store_1 = require("../store/store");
var owa_color_picker_1 = require("owa-color-picker");
var owa_session_store_1 = require("owa-session-store");
var React = require("react");
var ReactDOM = require("react-dom");
var react_1 = require("satcheljs/lib/legacy/react");
var ColorPickerButton = /** @class */ (function (_super) {
    tslib_1.__extends(ColorPickerButton, _super);
    function ColorPickerButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectColor = function (value) {
            _this.props.onSelectColor(value.code);
        };
        return _this;
    }
    ColorPickerButton.prototype.render = function () {
        var _this = this;
        var isShown = this.props.optionStore.isColorMenuShown;
        return (React.createElement("div", null,
            React.createElement(FormatButton_1.default, { type: "textcolor", isSelected: false, ref: function (ref) { return (_this.anchorButton = ReactDOM.findDOMNode(ref)); }, onClick: isShown ? this.onDismissMenu : this.onShowMenu }),
            isShown && (React.createElement(owa_color_picker_1.ColorPicker, { menuTargetElement: this.anchorButton, colors: owa_color_picker_1.textColors.get(), onDismissMenu: this.onDismissMenu, onSelectColor: this.onSelectColor, shouldFocusOnMount: true }))));
    };
    ColorPickerButton.prototype.onShowMenu = function () {
        toggleColorMenuIsShown_1.default(true);
    };
    ColorPickerButton.prototype.onDismissMenu = function () {
        toggleColorMenuIsShown_1.default(false);
    };
    ColorPickerButton = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], ColorPickerButton);
    return ColorPickerButton;
}(React.Component));
exports.default = ColorPickerButton;
//# sourceMappingURL=ColorPickerButton.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-message-format-option/lib/components/ColorPickerButton.js
// module id = 5150
// module chunks = 2